@use "../../styling/typography.scss" as *;
@use "../../styling/colors.scss" as *;

.Root {
  @extend %font-family-primary;

  display: grid;
  grid-template-columns: max-content 1fr;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  font-size: $font-size-normal;
  line-height: 18px;
  padding: 12px 16px;
  gap: 8px;
  align-items: center;
  color: $theme-color-table-text;
  text-align: start;
  max-height: 318px;
  overflow: hidden;

  &.hidesBorder {
    border: transparent;
  }

  &.isExpanded {
    max-height: 600px;
  }

  .icon {
    align-self: flex-start;
  }

  .contentWrapper {
    height: 100%;
  }

  .title {
    font-weight: $font-weight-bold;
    color: $theme-color-statuschip-text;
  }

  strong {
    font-weight: $font-weight-semibold;
  }

  >div {
    margin: 0;
    word-break: break-word;
  }

  dfn {
    font-style: normal;
  }

  .content {
    display: grid;
    gap: 2px;
    overflow: hidden;

    &.isExpanded {
      padding-right: 15px;
      max-height: 552px;
      overflow-y: auto;
    }

    &.hasMaxHeight {
      max-height: 252px;
    }
  }

  .button {
    display: grid;
    justify-content: start;
  }

  &.noneWithIcon {
    border-color: $theme-color-table-border;
    background: $theme-color-deepest;

    .icon {
      stroke: $theme-filter-icon-color;
    }

    dfn {
      color: $theme-filter-icon-color;
    }
  }

  &.noneStatus {
    @extend .noneWithIcon;

    .icon {
      color: $theme-filter-icon-color;
      align-self: start;
      margin-top: 1px;
    }
  }

  &.none {
    @extend .noneWithIcon;

    grid-template-columns: 1fr;
  }

  &.info {
    border-color: $theme-color-info-border;
    background: $theme-color-info;

    .icon {
      stroke: $theme-color-info-icon;
    }

    dfn {
      color: $theme-color-info-border;
    }
  }

  &.success, &.successDuplicate, &.successSwitch {
    border-color: $theme-color-success-border;
    background: $theme-color-success;

    .icon {
      color: $theme-color-success-icon;
    }

    dfn {
      color: $theme-color-success-border;
    }
  }

  &.warning {
    border-color: $theme-color-warning-border;
    background: $theme-color-warning;

    .icon {
      stroke: $theme-color-warning-icon;
    }

    dfn {
      color: $theme-color-warning-border;
    }
  }

  &.error {
    border-color: $theme-color-error-border;
    background: $theme-color-error;

    .icon {
      stroke: $theme-color-error-icon;
    }

    dfn {
      color: $theme-color-error-border;
    }
  }

  &.ignore {
    @extend .noneWithIcon;

    .icon {
      color: $theme-color-dnd-icon;
    }
  }

  &.tip {
    border-color: $theme-color-tip-border;
    background: $theme-color-tip;

    .icon {
      stroke: $theme-color-tip-icon;
    }

    dfn {
      color: $theme-color-tip-border;
    }
  }

  &.successStatus {
    padding: 8px;
    border-color: $color-secondary-green-10;
    background: $color-secondary-green-10;
    color: $theme-color-text;

    // margin-top derived from lineHeight 18 minus icon 16 then divide 2
    .icon {
      color: $theme-color-success-icon;
      align-self: start;
      margin-top: 1px;
    }

    dfn {
      color: $theme-color-success-border;
    }
  }

  &.warningStatus {
    padding: 8px;
    border-color: $color-warning-orange-10;
    background: $color-warning-orange-10;
    color: $theme-color-text;

    .icon {
      color: $theme-color-warning-icon;
      align-self: start;
      margin-top: 1px;
    }

    dfn {
      color: $theme-color-warning-border;
    }
  }

  &.errorStatus {
    padding: 8px;
    border-color: $theme-color-error-border;
    background: $theme-color-error;
    color: $theme-color-text;

    .icon {
      color: $theme-color-error-icon;
      align-self: start;
      margin-top: 1px;
    }

    dfn {
      color: $theme-color-error-border;
    }
  }

  &.unchangedStatus {
    padding: 8px;
    border-color: $theme-color-table-border;
    background: $theme-color-deepest;
    color: $theme-color-text;

    .icon {
      color: $theme-color-dnd-icon;
      align-self: start;
      margin-top: 1px;
    }

    dfn {
      color: $theme-filter-icon-color;
    }
  }
}
